module.exports = __webpack_public_path__ + "img/7.b71c2b4c.svg";